/**
 * @file コンポーネント：フル動画ページコントローラー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledController = styled.div`
    position: relative;
    background-color: #25292d;

    ${mediaQuery.sp(`
        margin: 0 24px 16px;
        height: 400px;
    `)};

    ${mediaQuery.spWide(`
        margin: 0 24px 16px;
        height: 400px;
    `)};

    ${mediaQuery.tablet(`
        margin: 0 24px 16px;
        height: 400px;
    `)};

    ${mediaQuery.pc(`
        width: 25%;
    `)};

    ${mediaQuery.pcWide(`
        width: 25%;
    `)};

    [data-name="tab"] {
        height: 100%;
    }

    [data-name="tab-contentlist"] {
        height: 100%;
        overflow-y: auto;
    }
`;

export const StyledControllerLoading = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${zIndex.fullvideoContentsController};
    width: 100%;
    height: 100%;
    background-color: #25292d;
`;
